

export const formatPrice = amount => {
  let val = (amount / 1).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export const FormatCnpjCpf = value => {
  const cnpjCpf = `${value}`.replace(/\D/g, '');

  if (cnpjCpf.length === 11) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }
  return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
}

export const formatCellPhone = value => {

  const cellPhone = `${value}`.replace(/\D/g, '');
  return cellPhone.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3");

}

 export const FormatCep = cep => {

  const cellPhone = `${cep}`.replace(/\D/g, '');
  return cellPhone.replace(/(\d{5})(\d{3})/g, "$1-$2");

 }

export const ToInt = value => {
  return value ? parseInt(value) : 0
}